import type { AwardPayout } from '../meta/online/awards';

/**
 * The note for holding bonuses just paid (docs/ONLINE.md, "Boards"): what each was for, the coins,
 * and the crown. Lines stay within the 192 px screen's 30 characters.
 */
export function awardMessage(p: AwardPayout): string {
  const { daily = 0, endless = 0, featured = 0 } = p.counts;
  const lines: string[] = [];
  if (p.crown) lines.push('You won the weekly lawn!', 'Crown Paint is yours.', '');
  if (p.coins > 0) {
    lines.push('Top 10 bonus!', '');
    if (daily) lines.push(`Dailies: ${daily}`);
    if (endless) lines.push(`Endless weeks: ${endless}`);
    if (featured) lines.push(`Weekly lawns: ${featured}`);
    lines.push('', `+${p.coins} coins`);
  }
  while (lines.at(-1) === '') lines.pop();
  return lines.join('\n');
}
